import { observer } from "mobx-react";
import React from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import {
	CategoryItems,
	SelectedSportCheckBox,
	SportsList,
} from "@features/offer/desktop/offer-menu/components";
import { ExpandedTopTournamentMenu } from "@features/offer/desktop/offer-menu/components/expanded-top-tournament-menu";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import PeriodConverter, { Period } from "@state/common/PeriodConverter";
import range from "lodash/range";

export const ExpandedOfferMenuCore = observer(
	function ExpandedOfferMenuCore(props: {
		store: {
			isEmpty: boolean;
			isLoading: boolean;
			toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
			selectedSport: PrematchOfferMenuStore["selectedSport"];
			menu: PrematchOfferMenuStore["menu"];
			type: "PrematchOfferMenuStore" | "LiveOfferMenuStore";
		};
	}) {
		const t = useTranslation().t;

		const { period } = useParams<{ period: Period }>();
		const isOfferHistoryPeriod = PeriodConverter.IsDateString(period);

		if (props.store.isEmpty) {
			return (
				<div className="u-padd--xsml u-padd--top--reset">
					<div className="card--empty u-mar--bottom--reset u-mar--top--xsml">
						<div className="card--empty__content">
							<i className="card--empty__icon u-icon u-icon--xlrg u-icon--empty u-icon--empty--search" />
							<div className="card--empty__message u-mar--bottom--reset">
								{t<string>(isOfferHistoryPeriod ? "OFFER_HISTORY.NO_EVENTS_MESSAGE" : "PREMATCH.SIDEMENU.EMPTY_STATE")}
							</div>
						</div>
					</div>
				</div>
			);
		}

		if (props.store.isLoading) {
			return (
				<div className="loader--skeleton loader--skeleton--content loader--skeleton--nav-tertiary">
					{range(1, 11).map((i) => (
						<div key={i} className="loader--skeleton__item">
							<div className="loader--skeleton__icon" />
							<div className="loader--skeleton__title loader--skeleton__title--med" />
						</div>
					))}
				</div>
			);
		}
		if (props.store.selectedSport != null) {
			if (props.store.selectedSport.node.isTopTournament) {
				return <ExpandedTopTournamentMenu store={props.store} />;
			} else {
				return (
					<>
						<SelectedSportCheckBox
							sport={props.store.selectedSport}
							store={props.store}
						/>
						<CategoryItems
							sport={props.store.selectedSport}
							store={props.store}
						/>
					</>
				);
			}
		}

		return <SportsList store={props.store} />;
	}
);
